export default "__VITE_ASSET__CRmLGv9q__"